<template>
    <li class="dropzone-item">
        <div class="item-content">
            <div class="file-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                </svg>
            </div>
            <div class="file-info">
                <div class="file-header">
                    <span class="file-name">{{ item.name }}</span>
                    <span class="file-size">{{ size }}</span>
                    <button type="button" class="cancel-btn" aria-label="Remove file" @click="onItemCancel">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <line x1="18" y1="6" x2="6" y2="18" />
                            <line x1="6" y1="6" x2="18" y2="18" />
                        </svg>
                    </button>
                </div>
                <div class="progress-track">
                    <div class="progress-fill" :style="{ width: `${item.upload.progress}%` }"></div>
                </div>
                <span class="file-status">{{ item.status }}</span>
            </div>
        </div>
    </li>
</template>

<script lang="ts">
import type { DropzoneFile } from 'dropzone'
import bytes from 'pretty-bytes'
import { Component, Emit, Prop, toNative, Vue } from 'vue-facing-decorator'

@Component({
    emits: ['itemCancel'],
})
class DropzoneItem extends Vue {
    declare $parent: any

    @Prop({ type: Object })
    readonly item!: DropzoneFile

    @Emit('itemCancel')
    onItemCancel(e) {
        return { file: this.item, e }
    }

    get size() {
        return bytes(this.item.size)
    }

    update(file: DropzoneFile) {
        if (this.item.upload.uuid === file.upload.uuid) this.$forceUpdate()
    }

    created() {
        this.$parent.dropzone.on('uploadprogress', (file) => this.update(file))
        this.$parent.dropzone.on('success', (file) => this.update(file))
        this.$parent.dropzone.on('error', (file) => this.update(file))
        this.$parent.dropzone.on('canceled', (file) => this.update(file))
        this.$parent.dropzone.on('complete', (file) => this.update(file))
    }
}
export default toNative(DropzoneItem)
</script>

<style scoped lang="scss">
.dropzone-item {
    list-style: none;
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
        border-bottom: none;
    }
}

.item-content {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.file-icon {
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    background: #f5f5f5;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
}

.file-info {
    flex: 1;
    min-width: 0;
}

.file-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
}

.file-name {
    font-size: 13px;
    font-weight: 500;
    color: #111;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    min-width: 0;
}

.file-size {
    font-size: 12px;
    color: #888;
    flex-shrink: 0;
}

.cancel-btn {
    flex-shrink: 0;
    background: none;
    border: none;
    padding: 2px;
    cursor: pointer;
    color: #aaa;
    display: flex;
    align-items: center;
    border-radius: 4px;
    transition: color 0.15s, background 0.15s;

    &:hover {
        color: #333;
        background: #f0f0f0;
    }
}

.progress-track {
    height: 3px;
    background: #f0f0f0;
    border-radius: 2px;
    overflow: hidden;
    margin-bottom: 4px;
}

.progress-fill {
    height: 100%;
    background: #111;
    border-radius: 2px;
    transition: width 0.3s ease;
}

.file-status {
    font-size: 11px;
    color: #999;
}
</style>
